// sections/featured-products
$(document).on(
  "staticClick.flickityt4s",
  ".t4s-imgs-preview.flickityt4s",
  function (event, pointer, cellElement, cellIndex) {
    if (!cellElement) {
      return;
    }
    event.preventDefault();
    var $this = $(cellElement).find("[data-t4s-click-on]");
    let action_to = $this.data("connect");
    $(".t4s-sc-f-colls .item--click-on.t4s--opend").removeClass("t4s--opend");
    $(action_to + ", .t4s-sc-f-colls--click-on").addClass("t4s--opend");
    setTimeout(function () {
      $(action_to).removeClass("t4s--opend").addClass("t4s--opended");
    }, 300);
    $(action_to)
      .attr("data-height", $(action_to).outerHeight() + "px")
      .css("--height", $(action_to).outerHeight() + "px");
    $(".t4s-sc-f-colls .t4s-sc-f-colls--click").css(
      "--height",
      $(action_to).attr("data-height")
    );
    $(action_to).find(".flickityt4s").flickityt4s("resize");
  }
);
$(document).on(
  "click",
  ".t4s-sc-f-colls .t4s-f-colls--close",
  function (event) {
    event.preventDefault();
    $(this)
      .parents(".t4s-sc-f-colls .item--click-on")
      .removeClass("t4s--opend t4s--opended");
    $(".t4s-sc-f-colls--click").css("--height", "");
    $(".t4s-sc-f-colls--click-on").removeClass("t4s--opend");
  }
);
setTimeout(function () {
  $.each($(".t4s-sc-f-colls .t4s-f-colls--desc"), function (index, id) {
    $(this).css("--height", $(this).outerHeight() + "px");
  });
}, 300);

// Product page
$(document).on("click", ".t4s-pr__video-btn", function (e) {
  $('[data-mdtype="video"]').trigger("click");
});

$(document).on("click", "[name=purchase_option]", function () {
  var el_mirror = $(this).attr("id");
  $(this)
    .parents("fieldset")
    .find("[name=selling_plan]")
    .attr("disabled", "disabled");
  $("label[for=" + el_mirror + "] [name=selling_plan]").removeAttr("disabled");
});

// Mobile Menu float
$(document)
  .on("click", ".t4s-menu-basic .t4s-mb-nav__icon-float", function (e) {
    e.preventDefault();
    var id_child = $(this).attr("data-child");
    $(id_child).addClass("is--opend");
    $(this).parents(".t4s-menu-item").first().addClass("is--opend");
    if (id_child.indexOf("item_grandchild") >= 0) {
      $(".t4s-drawer-menu__back")
        .css({ opacity: 1 })
        .attr({ "data-grandchild": id_child });
    } else {
      $(".t4s-drawer-menu__back")
        .css({ opacity: 1 })
        .attr({ "data-child": id_child });
    }
  })
  .on("click", ".t4s-menu-basic .t4s-title-parent", function (e) {
    e.preventDefault();
    $(this).parent().removeClass("is--opend");
    var id_child = $(this).parent().attr("id");
    $('[data-child="#' + id_child + '"]')
      .parents(".t4s-menu-item")
      .first()
      .removeClass("is--opend");
  })
  .on("click", ".t4s-menu-basic .t4s-only_icon_false", function (e) {
    e.preventDefault();
    $this = $(this).find(".t4s-mb-nav__icon-float");
    $($this.attr("data-child")).addClass("is--opend");
    $this.parents(".t4s-menu-item").first().addClass("is--opend");
  })
  .on("click", ".t4s-menu-basic .t4s-drawer-menu__back", function (e) {
    var id_child = $(this).attr("data-child");
    var id_gchild = $(this).attr("data-grandchild");
    if (id_gchild !== "") {
      $(id_gchild).removeClass("is--opend");
      $(this).attr("data-grandchild", "");
    } else {
      $(id_child).removeClass("is--opend");
      $(this).attr("data-child", "");
      $(".t4s-drawer-menu__back").css({ opacity: 0 });
    }
  });

$(".t4s-brands-filter button").click(function () {
  $(".t4s-brands-source__linklist").css({
    height: $(".t4s-brands-source__linklist").height(),
  });
  $(".t4s-brands-source__linklist .t4s-filter-item").each(function () {
    $(this).attr("data-height", $(this).height());
  });
  var dataFilter = $(this).data("filter");
  $(".t4s-brands-filter button").removeClass("is--active");
  $(this).addClass("is--active");

  if (dataFilter == "all") {
    $(".t4s-brands-source__linklist").css({ height: "" });
    $(".t4s-brands-source__linklist").children("div.t4s-filter-item").show(400);
  } else {
    $(".t4s-brands-source__linklist")
      .children("div:not(." + dataFilter + ")")
      .hide(400);
    var height = 0;
    $(".t4s-brands-source__linklist")
      .children("div." + dataFilter)
      .each(function () {
        height += $(this).height();
      });
    $(".t4s-brands-source__linklist").css({ height: height });
    $(".t4s-brands-source__linklist")
      .children("div." + dataFilter)
      .show(400);
  }
});

// Close search with ESC
$("body").on("keyup.drawer", function (e) {
  if (e.keyCode !== 27) return;
  $(".show-search").removeClass("show-search");
});

// progress bar in article pages
let prevScrollpos = $(window).offset.top;

$(document).on("scroll", function () {
  // sticky
  let currentScrollPos = $(window).scrollTop();
  if ($(window).scrollTop() > 300) {
    if (prevScrollpos < currentScrollPos) {
      $("#scroll-bar-article").addClass("is--active");
    } else {
      $("#scroll-bar-article").removeClass("is--active");
    }
  }
  prevScrollpos = currentScrollPos;
  // progress bar
  let scrollTop2 = window.scrollY;
  let docHeight = document.body.offsetHeight;
  let winHeight = window.innerHeight;
  let scrollPercent = scrollTop2 / (docHeight - winHeight);
  let scrollPercentRounded = Math.round(scrollPercent * 100);
  $("#article-progress-bar").css("width", `${scrollPercentRounded}%`);
});
// scroll to comment
$(document).on("click", "#scroll-bar-comment", function () {
  $("html, body").animate(
    {
      scrollTop: $("#CommentForm").offset().top,
    },
    1000
  );
});

$(document).on('click','#t4s-backTop', function () {
  $('html, body').animate({
      scrollTop: 0
  }, 800);
 });

 $(document).on('click', 'a[href*="preview_theme_id="]', function(event){
  var $this = $(this);
  event.preventDefault();
  $.ajax({
    type: "POST",
    url: Shopify.routes.root+'cart.js',
    data: {"attributes[collection_items_per_row]": ""},
    dataType: 'json'
  }).done(function() {
    window.location.href = $this.attr("href");
  });
})